import { Type } from "class-transformer";
import { MailHistoryOutDTO } from "./mail-history.out.dto";

export class MailHistoryPaginatedOutDTO {
  @Type(() => MailHistoryOutDTO)
  mails!: MailHistoryOutDTO[];
  total!: number;
}
